import { IApplicationState } from '../../types/redux';

// TODO: Удалить флаг в CD-206457
export const getIsNewbuildingBrokerEntryRedesignEnabled = (state: IApplicationState) =>
  state.config.isNewbuildingBrokerEntryRedesignEnabled;
